import axios from 'axios'
import okeResponse from 'okeoke.standardresponse'
import { localStorage } from 'okeoke.localstorage'

let Contents = function (endpoint) {
  this.contents = {}

  this.getContents = async (locationUUID, app) => {
    try {
      let response = await axios.get(endpoint + `/api/v1/contents/${app}?locationUUID=${locationUUID}`)
      return response.data
    } catch (error) {
      return okeResponse(false, 500, 'Error fetching data', null)
    }
  }
}

export { Contents }
